import Swiper from 'swiper';

export default class CarouselService {
  constructor() {
    this.instances = {};
  }

  create(carouselName, newOptions = {}) {
    const defaultOptions = {pagination: '.swiper-pagination'};
    const options = Object.assign({}, defaultOptions, newOptions);
    this.instances[carouselName] = new Swiper('.swiper-container', options);
    return this.instances[carouselName];
  }

  get(carouselname) {
    return this.instances[carouselname];
  }

  destroy(carouselname) {
    this.instances[carouselname] && this.instances[carouselname].destroy(true, true);
    delete this.instances[carouselname];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/carousel/carousel.service.js